import { Checkbox, FormLabel, Link } from '@chakra-ui/react';
import { useInvestorAccountModel } from '@common/models/InvestorAccountModel';
import React from 'react';
import { TextBlock } from 'src/apps/invest/common/components/TextBlock';
import { LINKS } from 'src/apps/invest/config';
import { useCheckoutSFRViewModel } from '../../../models/CheckoutSFRViewModel';

type AgreementProps = {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

export const Agreement: React.FC<AgreementProps> = ({ onChange }) => {
  const model = useCheckoutSFRViewModel();
  const investorAccountModel = useInvestorAccountModel();
  const subscriptionAgreement = model.property?.subscription_doc?.download_url ?? '';
  const hasAnsweredBrokerDealerQuestion =
    investorAccountModel?.investorAccount?.non_accredited_survey_v2?.broker_dealer_assoc?.value ?? null !== null;
  const isBrokerDealer = Boolean(
    investorAccountModel?.investorAccount?.non_accredited_survey_v2?.broker_dealer_assoc?.value ?? false,
  );
  return (
    <>
      <FormLabel alignItems={'flex-start'} gap="20px" display={'flex'} flexDirection="row" cursor={'pointer'}>
        <Checkbox
          isChecked={model.confirmAgreement}
          onChange={onChange}
          iconSize={'30px'}
          size="lg"
          mt={'4px'}></Checkbox>
        <TextBlock fontSize="16px" color="blackAlpha.700">
          By confirming, you are authorizing us to intiate an ACH transfer on your behalf based on our{' '}
          <Link href={LINKS.EFT_POLICY} target="_blank">
            Electronic Funds Transfer policy
          </Link>
        </TextBlock>
      </FormLabel>
      {!hasAnsweredBrokerDealerQuestion ? (
        <TextBlock fontSize="16px" color="blackAlpha.700">
          You are acknowledging that all the information you provided is correct and current. You represent that you are
          not affiliated with a broker-dealer. In addition, you are agreeing to use your stored e-signature in
          accordance with our{' '}
          <Link href={LINKS.ESIGN} target="_blank">
            E-Signature Policies
          </Link>{' '}
          to sign the associated{' '}
          <Link href={subscriptionAgreement} target="_blank">
            Subscription Agreement
          </Link>{' '}
          with this Offering for <i>{model.property?.display_name}</i>.
        </TextBlock>
      ) : isBrokerDealer ? (
        <TextBlock fontSize="16px" color="blackAlpha.700">
          You acknowledge that all the information you provided is correct and current. In addition, you are agreeing to
          use your stored e-signature in accordance with our{' '}
          <Link href={LINKS.ESIGN} target="_blank">
            E-Signature Policies
          </Link>{' '}
          to sign the associated{' '}
          <Link href={subscriptionAgreement} target="_blank">
            Subscription Agreement
          </Link>{' '}
          with this Offering for <i>{model.property?.display_name}</i>.
        </TextBlock>
      ) : (
        <TextBlock fontSize="16px" color="blackAlpha.700">
          You are acknowledging that all the information you provided is correct and current. You represent that you are
          not affiliated with a broker-dealer. In addition, you are agreeing to use your stored e-signature in
          accordance with our{' '}
          <Link href={LINKS.ESIGN} target="_blank">
            E-Signature Policies
          </Link>{' '}
          to sign the associated{' '}
          <Link href={subscriptionAgreement} target="_blank">
            Subscription Agreement
          </Link>{' '}
          with this Offering for <i>{model.property?.display_name}</i>.
        </TextBlock>
      )}
    </>
  );
};
